<template>
  <div>
    <app-header><app-nav></app-nav></app-header>
    <section class="container">
      <div class="page-header">
        <h2>Tempo de Prova</h2>
      </div>
      <p v-if="!horaInicio">A prova ainda não iniciou...</p>
  		<h1 class="text-center tempo" v-if="horaInicio">{{ tempoProva }}</h1>
  		<br>
    </section>
  </div>
</template>

<script>
import AppHeader from '@/pages/layout/Header.vue'
import AppNav from './Nav.vue'
import axios from 'axios'
import moment from 'moment'

export default {
  name: 'Tempo',
  components: {
    AppHeader,
    AppNav
  },
  data() {
    return {
      horaInicio: '00:00:00',
      tempoProva: '00:00:00'
    }
  },
  methods: {
    getHoraPartida() {
      axios.get(process.env.WEB_API + 'getHoraPartida.php')
        .then(response => this.horaInicio = response.data.hora)
    },
    calculaTempoProva() {
      this.tempoProva = moment(moment().diff(moment(this.horaInicio, 'HH:mm:ss'))).format('HH:mm:ss')
    }
  },
  mounted() {
    this.getHoraPartida();
    var timer = setInterval(function(){
      this.calculaTempoProva()
    }.bind(this), 1000);
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.tempo {
	margin-top: 15vh;
	font-size: 20vw;
}
</style>



// WEBPACK FOOTER //
// Tempo.vue?75dfd932